// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3iBG5","paramInput":"JobSimulator_paramInput__3Bwji","input":"JobSimulator_input__aqlwW"};